import React from "react";

import { Input, Select } from "antd";

import { SearchOutlined } from "@ant-design/icons";

const { Option } = Select;

const LdasProductFilterBar = ({
  searchText,
  onSearchChange,
  // selectedBrand,
  // onBrandChange,
  // selectedCategory,
  // onCategoryChange,
  // brands,
  // categories,
}) => {
  return (
    <div className="ldas-filter-bar">
      <Input
        className="ldas-filter-bar__search"
        prefix={<SearchOutlined className="ldas-filter-bar__search-icon" />}
        placeholder="🔍 제품 검색, 브랜드 검색.."
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        aria-label="제품명 또는 브랜드 검색"
      />
      {/* <Select
        className="ldas-filter-bar__select-brand"
        placeholder="브랜드"
        allowClear
        value={selectedBrand}
        onChange={onBrandChange}
        aria-label="브랜드 필터"
      >
        {brands.map((brand) => (
          <Option key={brand} value={brand}>
            {brand}
          </Option>
        ))}
      </Select>
      <Select
        className="ldas-filter-bar__select-category"
        placeholder="카테고리"
        allowClear
        value={selectedCategory}
        onChange={onCategoryChange}
        aria-label="카테고리 필터"
      >
        {categories.map((cat) => (
          <Option key={cat} value={cat}>
            {cat}
          </Option>
        ))}
      </Select> */}
    </div>
  );
};

export default LdasProductFilterBar;
